// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21DOu","type":"styles_type__2mPnJ","choices":"styles_choices__13A8Q"};